import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper, getSemanticTextColor } from '../../../utils';

export const PyramidMiniIcon = ({ width = 17, color = 'black', marginRight, marginLeft }: DefaultIconProps) => (
  <DefaultIconWrapper marginLeft={marginLeft} marginRight={marginRight} width={width}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 15">
      <path
        fill={getSemanticTextColor(color)}
        fillRule="evenodd"
        d="M9.198 10.136l1.81 4.116H.842c-.647 0-1.051-.7-.728-1.26l1.649-2.856h7.435zm5.238 0l1.65 2.856c.322.56-.082 1.26-.729 1.26h-2.74l-1.81-4.116h3.63zM11.49 5.034l2.096 3.629H2.613l2.095-3.63h6.782zM7.372.42c.324-.56 1.132-.56 1.456 0l1.813 3.141H5.558z"
      />
    </svg>
  </DefaultIconWrapper>
);
